/*
  FluoFree — gedeelde koopstate voor ff-koopblok, ff-koopbalk en ff-eind-cta.

  Eén bestand voor drie secties, omdat ze dezelfde twee dingen tonen: de prijs en
  of de extra filterset is aangevinkt. Zou elke sectie dat zelf bijhouden, dan
  loopt de sticky balk uit de pas met het koopblok zodra de bezoeker scrollt.

  De secties praten uitsluitend via data-attributen met dit bestand; er is geen
  gedeelde Liquid-state en geen globale CSS-selector nodig.

    [data-ff-koop-form]         formulier, met data-hoofd-variant / data-bump-variant
    [data-ff-koop-bump-line]    verborgen regel 2, staat serverzijdig op disabled
    [data-ff-koop-bump-toggle]  de checkbox (alleen in het koopblok)
    [data-ff-koop-bump-wrap]    de omhulling van die checkbox; staat serverzijdig
                                verborgen en wordt hier zichtbaar gemaakt
    [data-cadeau-varianten]     komma-lijst met cadeau-varianten op het formulier
    [data-ff-koop-gebonden]     door dit script gezet; voorkomt dubbele listeners
    [data-ff-koop-prijs]        prijsnode met data-basis en data-met-bump
    [data-ff-koop-bump-note]    tekst die alleen bij een aangevinkte bump zichtbaar is
    [data-ff-koop-basis-note]   tekst die juist verdwijnt zodra de bump aan staat

  Beide bedragen zijn serverzijdig door Liquid opgemaakt en staan als attribuut
  klaar. De browser hoeft daardoor nooit zelf valuta te formatteren, wat scheelt
  in fouten rond scheidingstekens en afronding.
*/
(function () {
  'use strict';

  var bumpAan = false;
  /* Koopkeuze 2: apparaat eenmalig + de bijbehorende filterset met selling plan.
     De radio draagt variant en plan; de staat is globaal, zodat de sticky balk
     en de eind-CTA dezelfde twee regels sturen als het koopblok. */
  var abo = null;
  /* Gekozen variant-id. Er staat vandaag één variant per apparaat, maar de
     Klarna-regel leest hem toch uit de kaart data-varianten: komt er ooit een
     kiezer bij, dan klopt het termijnbedrag meteen mee. */
  var variantId = null;

  function alle(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* Zet elke prijsnode, checkbox, notitie en verborgen cart-regel op de huidige
     stand. Wordt na elke wijziging in zijn geheel gedraaid: goedkoop genoeg, en
     het maakt het onmogelijk dat één sectie achterblijft. */
  function synchroniseer() {
    alle('[data-ff-koop-prijs]').forEach(function (el) {
      var waarde = bumpAan ? el.getAttribute('data-met-bump') : el.getAttribute('data-basis');
      if (waarde && el.textContent !== waarde) el.textContent = waarde;
    });
    /* Klarna-termijnregel. Serverzijdig opgemaakte bedragen: met de bump aan de
       zin bij het totaal, anders die van de gekozen variant. De browser rekent
       niets uit en formatteert geen valuta. */
    alle('[data-ff-klarna]').forEach(function (el) {
      var span = el.querySelector('[data-ff-klarna-tekst]');
      if (!span) return;
      var waarde = bumpAan ? el.getAttribute('data-met-bump') : el.getAttribute('data-basis');
      if (!bumpAan && variantId) {
        var sjabloon = el.getAttribute('data-sjabloon');
        var kaart = {};
        try { kaart = JSON.parse(el.getAttribute('data-varianten') || '{}'); } catch (e) { kaart = {}; }
        if (sjabloon && kaart[variantId]) waarde = sjabloon.replace('[[BEDRAG]]', kaart[variantId]);
      }
      if (waarde && span.textContent !== waarde) span.textContent = waarde;
    });
    alle('[data-ff-koop-bump-note]').forEach(function (el) { el.hidden = !bumpAan; });
    alle('[data-ff-koop-basis-note]').forEach(function (el) { el.hidden = bumpAan; });
    alle('[data-ff-koop-bump-toggle]').forEach(function (cb) {
      if (cb.checked !== bumpAan) cb.checked = bumpAan;
    });
    /* De tweede cart-regel staat serverzijdig op disabled. Zonder JavaScript
       blijft hij dat, zodat een niet-werkende checkbox nooit stilzwijgend een
       filterset van 99 euro aan de bestelling toevoegt. */
    alle('[data-ff-koop-bump-line]').forEach(function (input) { input.disabled = !bumpAan; });
    alle('[data-ff-koop-abo-line]').forEach(function (input) { input.disabled = !abo; });
    /* Idem voor de formulier-POST: de cadeauregel van dezelfde filterset uit bij het abonnement. */
    alle('[data-ff-koop-cadeau]').forEach(function (input) {
      input.disabled = !!abo && input.getAttribute('data-ff-koop-cadeau') === String(abo.variant);
    });
  }

  function zetBump(waarde) {
    bumpAan = !!waarde;
    synchroniseer();
  }

  function toonFout(form, tekst) {
    var node = form.querySelector('[data-ff-koop-fout]');
    if (!node) return;
    node.textContent = tekst;
    node.hidden = false;
  }

  function knopBezig(knop, bezig) {
    if (!knop) return;
    var label = knop.querySelector('[data-ff-koop-knop-label]');
    if (bezig) {
      knop.setAttribute('aria-busy', 'true');
      knop.disabled = true;
      if (label && knop.getAttribute('data-bezig-label')) {
        knop.setAttribute('data-rustlabel', label.textContent);
        label.textContent = knop.getAttribute('data-bezig-label');
      }
    } else {
      knop.removeAttribute('aria-busy');
      knop.disabled = false;
      if (label && knop.getAttribute('data-rustlabel')) {
        label.textContent = knop.getAttribute('data-rustlabel');
      }
    }
  }

  /* Twee regels in één verzoek: /cart/add.js accepteert een items-array, zodat
     het toestel en de optionele filterset samen in de winkelwagen belanden en
     er geen tussenstand bestaat waarin alleen de filterset is toegevoegd. */
  function verstuur(form, e) {
    var hoofd = form.getAttribute('data-hoofd-variant');
    var bump = form.getAttribute('data-bump-variant');
    if (!hoofd || !window.fetch) return; /* laat de gewone formulier-POST staan */

    e.preventDefault();
    var knop = form.querySelector('[data-ff-koop-knop]');
    var foutnode = form.querySelector('[data-ff-koop-fout]');
    if (foutnode) foutnode.hidden = true;
    knopBezig(knop, true);

    /* Cadeaus gaan altijd mee — het zijn geen keuzes. Ze staan als gewone
       (niet-disabled) hidden inputs in het formulier, dus de fallback-POST
       stuurt exact dezelfde regels als deze fetch. Zelfde volgorde ook:
       hoofdproduct, cadeaus, dan pas de optionele bump. */
    var cadeaus = (form.getAttribute('data-cadeau-varianten') || '')
      .split(',')
      .filter(function (id) { return id !== ''; });

    var regels = [{ id: Number(hoofd), quantity: 1 }];
    /* Fase-ba: bij het abonnement ís de cadeau-filterset de abonnementsregel.
       Dezelfde variant gaat dan niet ook nog als losse cadeauregel mee. */
    cadeaus.forEach(function (id) {
      if (abo && String(id) === String(abo.variant)) return;
      regels.push({ id: Number(id), quantity: 1 });
    });
    if (bumpAan && bump) regels.push({ id: Number(bump), quantity: 1 });
    /* De filterset gaat als eigen regel mee, met het selling plan erop: alleen
       díe regel wordt een abonnement, het apparaat blijft eenmalig. */
    if (abo) regels.push({ id: Number(abo.variant), quantity: 1, selling_plan: Number(abo.plan) });

    /* De winkelwagen staat op 'lade'. Vraag de gerenderde secties meteen mee op,
       dan kan Dawn's cart-drawer ze plaatsen en zichzelf openen; zonder lade
       (of zonder secties in het antwoord) blijft de sprong naar /cart staan. */
    var lade = document.querySelector('cart-drawer');
    var kanLade = !!(lade && typeof lade.renderContents === 'function' && document.getElementById('CartDrawer'));
    var lading = { items: regels };
    if (kanLade) {
      lading.sections = 'cart-drawer,cart-icon-bubble';
      lading.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(lading)
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok) {
          knopBezig(knop, false);
          toonFout(form, (res.body && (res.body.description || res.body.message)) || form.getAttribute('data-fout-tekst') || '');
          return;
        }
        if (kanLade && res.body && res.body.sections && res.body.sections['cart-drawer']) {
          knopBezig(knop, false);
          lade.renderContents(res.body);
          return;
        }
        window.location.href = form.getAttribute('data-cart-url') || '/cart';
      })
      .catch(function () {
        /* Netwerk weg of geblokkeerd: val terug op de gewone formulier-POST,
           die exact dezelfde regels bevat. */
        knopBezig(knop, false);
        form.submit();
      });
  }

  /* Fotogalerij van het koopblok. Staat in dit bestand omdat het koopblok toch
     al dit script laadt; een tweede asset zou een extra request kosten. */
  function galerij(root) {
    var stage = root.querySelector('[data-ff-galerij-stage]');
    var thumbs = alle('[data-ff-galerij-thumb]', root);
    if (!stage || !thumbs.length) return;
    var videos = alle('[data-ff-galerij-video]', root);
    var index = 0;

    /* Een videothumb draagt data-video met de index van het media-item. De
       bijbehorende laag komt in beeld, het stagebeeld gaat eronder weg en elke
       andere video wordt gepauzeerd — anders speelt er geluid door terwijl je
       al een ander beeld bekijkt. */
    function toon(nieuw) {
      index = (nieuw + thumbs.length) % thumbs.length;
      var bron = thumbs[index];
      var videoId = bron.getAttribute('data-video');
      videos.forEach(function (laag) {
        var aan = videoId !== null && laag.getAttribute('data-ff-galerij-video') === videoId;
        laag.hidden = !aan;
        if (!aan) {
          var speler = laag.querySelector('video');
          if (speler && !speler.paused) speler.pause();
        }
      });
      stage.hidden = videoId !== null;
      if (videoId === null) {
        stage.src = bron.getAttribute('data-src') || stage.src;
        stage.alt = bron.getAttribute('data-alt') || '';
      }
      thumbs.forEach(function (t, i) { t.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { toon(i); });
    });
    var volgende = root.querySelector('[data-ff-galerij-next]');
    if (volgende) volgende.addEventListener('click', function () { toon(index + 1); });
  }

  /* Sticky koopbalk. Hij hoort er pas te staan als de koopknop van het koopblok
     voorbij is — niet meteen bovenaan de pagina, want dan staan er twee
     koopknoppen onder elkaar. De observer let daarom op het koopblok-formulier
     en kijkt of dat bóven het scherm is verdwenen; staat het nog onder de vouw
     (bij het laden), dan blijft de balk weg.

     Het attribuut data-ff-koopbalk-io zet de CSS-regel aan die de balk verbergt.
     Zonder IntersectionObserver zetten we dat attribuut niet, en blijft de balk
     dus zichtbaar zoals voor deze wijziging. */
  function koopbalk() {
    var balk = document.querySelector('[data-ff-koopbalk]');
    if (!balk) return;
    var anker = document.querySelector('.ff-koopblok [data-ff-koop-form]') || document.querySelector('.ff-koopblok');
    if (!anker || !('IntersectionObserver' in window)) return;
    balk.setAttribute('data-ff-koopbalk-io', '1');
    var gepland = false;

    function werkBij() {
      gepland = false;
      balk.classList.toggle('is-zichtbaar', anker.getBoundingClientRect().bottom <= 0);
    }

    function plan() {
      if (gepland) return;
      gepland = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(werkBij);
      else setTimeout(werkBij, 60);
    }

    new IntersectionObserver(plan, { threshold: 0 }).observe(anker);
    /* De observer meldt alleen of het formulier het scherm raakt. Bij een sprong
       (ankerlink uit de sectienav, terug-navigatie) gaat het formulier van boven
       het scherm naar onder het scherm: beide keren 'niet zichtbaar', dus de
       observer zwijgt en de balk zou blijven staan. Gemeten op 2026-09-20.
       Deze passieve luisteraar corrigeert dat met één rect-meting per frame. */
    window.addEventListener('scroll', plan, { passive: true });
    werkBij();
  }

  /* Trustpilot-score en -aantal. Het thema rendert de ingestelde waarden; hier
     worden alleen de getallen vervangen door de actuele cijfers uit het
     TrustBox-data-endpoint. Door alleen het getal te vervangen blijft de
     omliggende tekst in de taal van de pagina staan ("42 reviews op Trustpilot"
     / "42 avis sur Trustpilot"), zonder dat er een tweede vertaling nodig is.
     Mislukt het verzoek, dan blijft de ingestelde waarde staan. */
  function getalVervang(tekst, getal) {
    return String(tekst).replace(/\d+(?:[.,\u202f ]\d+)*/, getal);
  }

  function trustpilot() {
    var rij = document.querySelector('[data-ff-tp]');
    if (!rij || !window.fetch) return;
    var bu = rij.getAttribute('data-tp-bu');
    var sjabloon = rij.getAttribute('data-tp-template');
    if (!bu || !sjabloon) return;
    var locale = rij.getAttribute('data-tp-locale') || 'nl-NL';
    fetch('https://widget.trustpilot.com/trustbox-data/' + encodeURIComponent(sjabloon) +
          '?businessUnitId=' + encodeURIComponent(bu) +
          '&locale=' + encodeURIComponent(locale) + '&includeReviews=false')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var bu2 = data && (data.businessUnit || data.businessEntity);
        if (!bu2) return;
        var aantal = bu2.numberOfReviews && bu2.numberOfReviews.total;
        var score = bu2.trustScore;
        var scoreNode = rij.querySelector('[data-ff-tp-score]');
        var bronNode = rij.querySelector('[data-ff-tp-bron]');
        /* De oude teksten eerst bewaren: het aria-label bevat dezelfde twee
           strings en wordt daarmee letterlijk bijgewerkt, zonder gok over de
           volgorde van getallen in die zin. */
        var oudeScore = scoreNode ? scoreNode.textContent : '';
        var oudeBron = bronNode ? bronNode.textContent : '';
        if (scoreNode && typeof score === 'number') {
          /* Het scheidingsteken van de pagina aanhouden: 4,5 in het Nederlands,
             4.5 in het Engels. */
          var komma = scoreNode.textContent.indexOf(',') !== -1;
          var scoreTekst = String(score).replace('.', komma ? ',' : '.');
          scoreNode.textContent = getalVervang(scoreNode.textContent, scoreTekst);
        }
        if (bronNode && typeof aantal === 'number') {
          bronNode.textContent = getalVervang(bronNode.textContent, String(aantal));
        }
        var label = rij.getAttribute('aria-label');
        if (label) {
          if (oudeScore && scoreNode) label = label.split(oudeScore).join(scoreNode.textContent);
          if (oudeBron && bronNode) label = label.split(oudeBron).join(bronNode.textContent);
          rij.setAttribute('aria-label', label);
        }
        var tegels = alle('[data-ff-tp-tegel]', rij);
        if (tegels.length && typeof score === 'number') {
          var vol = Math.floor(score);
          var rest = score - vol;
          tegels.forEach(function (t, i) {
            var staat = 'leeg';
            if (i + 1 <= vol) staat = 'vol';
            else if (rest >= 0.25 && i + 1 === vol + 1) staat = 'half';
            t.setAttribute('data-staat', staat);
          });
        }
      })
      .catch(function () { /* cijfers blijven staan zoals ingesteld */ });
  }

  /* start() draait bij DOMContentLoaded én bij elke shopify:section:load. Er
     staan drie formulieren op de PDP (koopblok, koopbalk, eind-cta) en start()
     bindt ze allemaal, dus zonder markering kreeg elk formulier bij elke
     sectie-load een extra submit-listener erbij. Eén klik stuurde daardoor
     drie keer /cart/add.js en belandde alles in drievoud in de winkelwagen —
     gemeten op 2026-09-09. De markering staat op het element zelf, dus een
     door de editor opnieuw opgebouwde sectie levert verse nodes die alsnog
     netjes gebonden worden. */
  function gebonden(el) {
    if (el.getAttribute('data-ff-koop-gebonden')) return true;
    el.setAttribute('data-ff-koop-gebonden', '1');
    return false;
  }

  function start() {
    /* De checkbox is serverzijdig verborgen. Pas nu er echt een script draait
       dat de bumpregel kan aanzetten, mag hij in beeld komen. */
    alle('[data-ff-koop-bump-wrap]').forEach(function (el) {
      el.classList.remove('ff-koopblok__bump--zonder-js');
    });
    alle('[data-ff-koop-bump-toggle]').forEach(function (cb) {
      if (gebonden(cb)) return;
      cb.addEventListener('change', function () { zetBump(cb.checked); });
    });
    alle('[data-ff-koopkeuze] input[type="radio"]').forEach(function (radio) {
      if (gebonden(radio)) return;
      radio.addEventListener('change', function () {
        var aan = radio.hasAttribute('data-ff-koopkeuze-abo') && radio.checked;
        abo = aan && radio.getAttribute('data-abo-plan')
          ? { variant: radio.getAttribute('data-abo-variant'), plan: radio.getAttribute('data-abo-plan') }
          : null;
        synchroniseer();
      });
    });
    /* Variantwissel: elke kiezer die het veld `id` van het koopformulier zet. */
    alle('[data-ff-koop-form] [name="id"]').forEach(function (veld) {
      if (veld.value && (veld.type !== 'radio' || veld.checked)) variantId = veld.value;
      if (gebonden(veld)) return;
      veld.addEventListener('change', function () {
        variantId = veld.value;
        synchroniseer();
      });
    });
    alle('[data-ff-koop-form]').forEach(function (form) {
      if (gebonden(form)) return;
      form.addEventListener('submit', function (e) { verstuur(form, e); });
    });
    alle('[data-ff-galerij]').forEach(function (root) {
      if (gebonden(root)) return;
      galerij(root);
    });
    var balk = document.querySelector('[data-ff-koopbalk]');
    if (balk && !gebonden(balk)) koopbalk();
    var tp = document.querySelector('[data-ff-tp]');
    if (tp && !gebonden(tp)) trustpilot();
    synchroniseer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* De theme-editor bouwt een sectie opnieuw op zonder de pagina te herladen;
     zonder deze haak zouden de nieuwe knoppen geen listener meer hebben. */
  document.addEventListener('shopify:section:load', start);
})();
